import api from '@pray/shared/utils/api';

export interface ChatStats {
  totalChannels: number;
  unreadChannels: number;
  unreadMessages: number;
}

interface GetChatStatsParams {
  artistId: string;
}

/**
 * Fetch chat statistics from Sendbird via backend
 *
 * Returns accurate total channels, unread channels, and unread message counts
 * directly from the Sendbird API via the backend.
 *
 * @param params.artistId - Artist ID (required)
 * @returns Promise with chat stats
 */
export async function getChatStats({ artistId }: GetChatStatsParams): Promise<ChatStats> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/chats/stats`;
  const response = await api.executeGetRequest(url);

  // sendSuccessResponse wraps data as: { data: [{ resource: { ...stats } }] }
  const resource = (response?.data as any)?.data?.[0]?.resource;
  return resource || response.data;
}
